import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import * as qs from 'qs';
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {HelperService} from "app/lib/helper.service";
import {DomainBillingStats} from "app/models/domain_billing.model";
import {FilterParams} from "app/models/filter_form.model";
import {ChartParams} from "app/views/chart/chart.component";
import {ModalService} from "app/views/modal/base_modal.component";
import {MoneyDetailsComponent} from "app/domains/domain_billing/details/money_details/money_details.component";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import {PaidDetailsComponent} from "./details/paid_details/paid_details.component";

import dictionary from "dict/static.json";
import { BillingService2 } from "../../billing/billing.service";


@Component({
	selector: 'domain-billing',
	templateUrl: './domain_billing.component.html'
})
export class DomainBillingComponent extends BaseComponent {
	stats: DomainBillingStats[];
	
	totalLoader: boolean = false;
	paginationLoader: boolean = false;
	statsLoader: boolean = true;
	
	chartData = new ChartParams();
	
	public total = null;
	
	domainParamsMap = {
		'searchedCount': 'searchDomain',
		'searchedUniqCount': 'searchUniqDomain',
		'selectedCount': 'selectedDomain',
		'paidCount': 'paidDomain',
		'saveContactCount': 'saveContactDomain',
		'attachCount': 'attachDomain'
	};
	
	public currencyList;
	
	addFilterParams = {
		userType: 'user',
		isDomainBilling: true,
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated'],
		dateType: 'datePaid'
	};
	
	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		private http: HttpClient,
		private helper: HelperService,
		private modalService: ModalService,
		public service2: BillingService2,
	) {
		super(eventsService, service2, activatedRoute, filter, translate);
		
		this.chartData.setOptions({
			names: {
				'searchedCount': this.translate.__A('billing.domain_billing.searchedCount'),
				'searchedUniqCount': this.translate.__A('billing.domain_billing.searchedUniqCount'),
				'selectedCount': this.translate.__A('billing.domain_billing.selectedCount'),
				'saveContactCount': this.translate.__A('billing.domain_billing.saveContactCount'),
				'attachCount': this.translate.__A('billing.domain_billing.attachCount'),
				'paidCount': this.translate.__A('billing.domain_billing.paidCount'),
				"prolongationCount": this.translate.__A('billing.domain_billing.prolongationCount.title')
			}
		});
		
		this.filter.addFilters.push('promocode');
	}
	
	
	async ngOnInit() {
		super.ngOnInit();
		
		this.currencyList = dictionary.currencyList;
	}
	
	
	async getData() {
		await this.getChart();
		await this.getTotal();
		await this.getStats();
	}
	
	
	// Получить данные для тотала
	async getTotal() {
		if (this.dontLoad.total) {
			return true;
		}
		
		this.total = null;
		
		this.totalLoader = true;
		const { totals } = await this.service2.domainBilling.total(this.filter.filterParams).toPromise();
		this.total = totals;
		
		this.totalLoader = false;
	}
	
	
	// Получить данные для графика
	async getChart(params?: FilterParams) {
		if (this.dontLoad.chart) {
			return true;
		}
		
		this.chartData.showLoader();
		const { charts } = await this.service2.domainBilling.chart(
			this.filter.getCopyFilterParams(params)
		).toPromise();
		this.chartData.data = charts;
		this.chartData.hideLoader();
	}
	
	
	// Получить данные для пагинации
	async getStats() {
		let me = this;
		
		this.statsLoader = true;
		
		if (this.dontLoad.pagination) {
			await this.getTable();
			this.statsLoader = false;
			return true;
		}
		
		if (this.filter.filterParams.period !== 'summary') {
			this.paginationLoader = true;
			
			const pagination = await this.service2.domainBilling.pagination(this.filter.filterParams).toPromise();
			me.pagination.fill(pagination);
			
			if (pagination) {
				me.updateLinks(
					me.service2.domainBilling.getRealFullRoute()
				)
			}
			
			this.paginationLoader = false;
		}
		
		await this.getTable();
		
		this.statsLoader = false;
	}
	
	
	// Получить данные для stats
	async getTable() {
		const me = this;
		
		const { stats } = await me.service2.domainBilling.stats(
			me.filter.getCopyFilterParams({
				paginationDate: me.pagination.getDate()
			})
		).toPromise();
		me.stats = stats;
		
		for (let stat of me.stats) {
			const dates = me.helper.getTimeAsIntervals({
				timestamp: stat.timestamp,
				period: me.filter.filterParams.period
			});
			
			if (dates.length == 2) {
				stat.currentPeriod = dates[0] + '-' + dates[1];
			} else {
				stat.currentPeriod = dates[0];
			}
			
			stat.day = new Date(stat.timestamp).getDay();
			
			if (stat.currentPeriod == '') {
				stat.currentPeriod = 'summary';
			}
		}

		me.dontLoad = {};
	}
	
	
	// Клик по пагинации
	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;
		
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
		
		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];
		
		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});
		
		this.dontLoad = {
			total: true,
			chart: true,
			pagination: true
		};
	}
	
	
	async showMoneyDetails(key: string, stat: any, currencyType: string) {
		const modalRef = this.modalService.open(
			MoneyDetailsComponent,
			{
				title: this.translate.__A('billing.billing.' + key) + ': ' + stat.currentPeriod + ' (' + currencyType + ')'
			},
			{size: 'hg'}
		);
		
		let invoicePaidType = {
			domainProlongation: 300,
			buyDomain: 100
		}[key];
		
		const { stats } = await this.service2.domainBilling.detail(
			this.filter.getCopyFilterParams(
				<FilterParams>{
					currencyType, invoicePaidType,
					groupDate: stat.groupDate,
				}
			),
			'paid_detail'
		).toPromise();
		modalRef.componentInstance.details = stats;
	}
	
	
	async showDetails(key: string, stat: any) {
		let domainStatType = {
			'paidCount': 'paidDomain',
			'prolongationCount': 'prolongationCount'
		}[key];
		
		if (key === 'paidCount' || key === 'prolongationCount') {
			const modalRef = this.modalService.open(PaidDetailsComponent, {
				title: this.translate.__A('billing.domain_billing.' + key + '.title') + ': ' + stat.currentPeriod,
			}, {size: 'hg'});
			
			 const { stats } = await this.service2.domainBilling.detail(
				this.filter.getCopyFilterParams(
					<FilterParams>{
						domainStatType,
						groupDate: stat.groupDate,
					}
				),
				'detail'
			).toPromise();
			
			modalRef.componentInstance.details = stats;
		}
	}
	
	
	async updateData(filter) {
		await this.getChart(filter);
	}
}
